import { Component, Input } from '@angular/core';
import {
  BUTTON_STYLES,
  ICONS,
  REGISTRATION_TYPES,
} from '../../../constants/constants';
import { PopupService } from '../../../services/popup.service';
import { Router } from '@angular/router';
import { AUTH_ROUTES } from '../../../constants/routes';

@Component({
  selector: 'app-unauthorized-user-popup',
  templateUrl: './unauthorized-user-popup.component.html',
  styleUrls: ['./unauthorized-user-popup.component.scss'],
})
export class UnauthorizedUserPopupComponent {
  @Input() title: string;
  @Input() helpText: string;
  protected readonly ICONS = ICONS;
  protected readonly BUTTON_STYLES = BUTTON_STYLES;

  constructor(private popupService: PopupService, private router: Router) {}

  close(): void {
    this.popupService.closePopup();
  }

  goToSignUpPage(): void {
    this.close();
    this.router.navigate([
      `/auth/${AUTH_ROUTES.REGISTRATION}/${REGISTRATION_TYPES.ENTHUSIAST}`,
    ]);
  }
}
